<script lang="ts">
  import PrimaryMenu from './primary-menu.svelte';
  import AccountMenu from './account-menu.svelte';

  import {authService} from '$lib/stores/auth';
</script>

{#if $authService.matches('authd')}
  <PrimaryMenu />
{/if}

<AccountMenu />
